<template>
<article class="info-section">
  <div class="info-section-header">
    <InfoSectionHeading>{{heading}}</InfoSectionHeading>
    <p class="info-section-description">{{description}}</p>
    <div class="button-holder" v-if="isEditor">
      <router-link
        :to="`/${model}/create`"
        class="elr-button elr-button-primary"
      >Create New {{singular}}</router-link>
    </div>
  </div>
  <div class="filter">
    <slot name="filter" />
  </div>
  <ListItemGrid v-if="status && displayStyle === 'grid'" :status="status">
    <slot />
  </ListItemGrid>
  <div v-if="status && displayStyle === 'list'" class="item-list-holder">
    <slot name="list" />
  </div>
</article>
</template>

<script>
import { mapGetters } from 'vuex';
import { plural } from '../../utils/helpers';
import { infiniteScroll, capitalize, deslugify } from '../../utils/helpers';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';
import ListItemGrid from '../../components/ListItemGrid/ListItemGrid';

export default {
  name: 'ListItem',
  props: {
    displayStyle: {
      type: String,
      default: 'grid'
    },
    heading: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    items: {
      type: [Object, Array]
    },
    status: {
      type: String
    },
    nextUrl: {
      type: String
    }
  },
  computed: {
    ...mapGetters('currentUser', ['isEditor']),
    singular() {
      return capitalize(deslugify(this.model));
    },
    plural() {
      return plural(this.singular);
    }
  },
  components: {
    InfoSectionHeading,
    ListItemGrid
  },
  mounted() {
    infiniteScroll(() => {
      if (this.nextUrl && this.status !== 'loading') {
        this.$emit('onFetchMore');
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.filter {
  max-width: $max-width;
  margin-left: auto;
  margin-right: auto;
}

.button-holder {
  text-align: left;
}

.item-list-holder {
  max-width: $max-width;
  margin-left: auto;
  margin-right: auto;
}
</style>
